import React from 'react';
import { observer } from 'mobx-react-lite';

export const SelectCompany = observer(() => {
  return <></>;
});
